import { useEffect } from "react";

import { getMatomoSiteId, getMatomoUrl } from ".";

declare global {
  interface Window {
    _paq?: Array<any>;
  }
}

export function useMatomoTracker() {
  const siteId = getMatomoSiteId();
  const matomoUrl = getMatomoUrl();

  useEffect(() => {
    if (siteId && matomoUrl) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.defer = true;
      script.src = `${matomoUrl}/matomo.js`;
      document.body.appendChild(script);

      window._paq = window._paq || [];
      window._paq.push(["setDocumentTitle", "Page load"]);
      window._paq.push(["trackPageView"]);
      window._paq.push(["enableLinkTracking"]);
      window._paq.push(["setTrackerUrl", `${matomoUrl}/matomo.php`]);
      window._paq.push(["setSiteId", siteId]);
    }
  }, [siteId, matomoUrl]);

  return null;
}
